import { datadogRum } from '@datadog/browser-rum';
import Cookies from 'js-cookie';
import { getUserState } from '@carvana/core-auth';
import { BCID } from '../constants';
import { isMyCarsReskinFixed } from './myCarsReskinExperiment';

const initDataDog = () => {
  datadogRum.init({
    applicationId: '14f8c877-f3e6-43bf-b378-94001d63e92a',
    clientToken: 'pub7ffbb47ea98a4fab5aecb1c7462db695',
    site: 'datadoghq.com',
    service: 'my-carvana-op',
    env: process.env.NODE_ENV,
    // Specify a version number to identify the deployed version of the application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });

  datadogRum.setUser({
    // must use id since datadog's queryable columns are not dynamic
    id: Cookies.get(BCID),
    userId: getUserState().user?.user_id,
  });

  datadogRum.startSessionReplayRecording();

  datadogRum.setGlobalContextProperty('controlFixed', isMyCarsReskinFixed());
};

export default initDataDog;
